import { render, staticRenderFns } from "./AutomationNewModal.vue?vue&type=template&id=497b5587&"
import script from "./AutomationNewModal.vue?vue&type=script&lang=js&"
export * from "./AutomationNewModal.vue?vue&type=script&lang=js&"
import style0 from "./AutomationNewModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports